import { Box } from "@mui/material";
import { Close, FilterList } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { ConvertObjectTranslatedToArray } from "../../../Utils/ConvertObjetctTranslatedToArray";
import { PixTablesFilter } from "./FilterComponents/PixTablesFilter";
import { ReceiptFilter } from "./FilterComponents/ReceiptsFilter";
import { ExtractFilter } from "./FilterComponents/ExtractFilter";
import { TransfersFilter } from "./FilterComponents/TransfersFilter";
import { TicketsFilter } from "./FilterComponents/TicketsFilter";
import { useFilter } from "../../../Hooks/useFilter";
import { returningObjectWithoutNullProperties } from "../../../Utils/checkObjectProperties";
import { PixTotalsFilter } from "./FilterComponents/PixTotalsFilter";
import { PixStatementFilter } from "./FilterComponents/PixStatementFilter/index";
import { InvoiceFilter } from "./FilterComponents/InvoiceFilter";
import { FilterDialog } from "./FilterDialog";

const FILTER_CONTAINER_CLASS = "filter-bar";

interface TableFilterProps {
  tableName:
  | "pixPayment"
  | "pixReceive"
  | "pixTotals"
  | "pixStatement"
  | "receipt"
  | "extract"
  | "refunds"
  | "transfers"
  | "tickets"
  | "invoices"
  | "invoiceBuyers"
  | "invoiceDashboard"
  | "invoiceDuplicates";
  setPageToFirst: (query?: any) => void;
  className?: string;
  buttonClassName?: string;
  tagButtonClassName?: string;
}

export const TableFilter = ({
  tableName,
  setPageToFirst,
  className = FILTER_CONTAINER_CLASS,
  buttonClassName = "btn-filter",
  tagButtonClassName = "btn-filter-tag",
}: TableFilterProps) => {
  const appliedFilterButtonClass = tagButtonClassName;
  const [appliedFilters, setAppliedFilters] = useState([] as any);
  const [isOpen, setIsOpen] = useState(false);

  const { getFilterObj, handleRemoveFilters } = useFilter();
  const filterObj = getFilterObj(tableName) as any;

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  const handleRemoveFiltersByTags = (filterName: string) => {
    const newFilterObject = {
      ...filterObj,
      [filterName]: "",
    };

    handleRemoveFilters(tableName, newFilterObject);
    setPageToFirst();
  };

  useEffect(() => {
    let isMounted = true;

    const ObjectWithoutNullValues =
      returningObjectWithoutNullProperties(filterObj);
    let tagsFilter = ConvertObjectTranslatedToArray(ObjectWithoutNullValues, tableName);

    if (isMounted) {
      setAppliedFilters(tagsFilter);
      handleClose();
    }

    return () => {
      isMounted = false;
    };
  }, [filterObj, tableName]);

  return (
    <Box className={className}>
      <div className="filter-bar__content">
        <button
          type="button"
          className={buttonClassName}
          onClick={handleOpen}
        >
          <FilterList sx={{ fontSize: 14 }} />
          Aplicar Filtros
        </button>

        {(appliedFilters || []).map((filter, i) => {
          const label = Object.keys(filter)[0];
          const value = Object.values(filter)[0];
          const filterKey = Object.keys(filter)[1];

          return (
            <button
              key={i}
              type="button"
              className={appliedFilterButtonClass}
              onClick={() => handleRemoveFiltersByTags(filterKey)}
            >
              <span className="truncate">
                {label}: <strong>{value}</strong>
              </span>
              <Close sx={{ fontSize: 14, flexShrink: 0 }} />
            </button>
          );
        })}
      </div>

      <FilterDialog open={isOpen} onClose={handleClose}>
        {(tableName === "pixPayment" || tableName === "pixReceive") && (
          <PixTablesFilter
            tableName={tableName}
            setPageToFirst={setPageToFirst}
          />
        )}
        {tableName === "pixTotals" && (
          <PixTotalsFilter
            tableName={tableName}
            setPageToFirst={setPageToFirst}
          />
        )}
        {tableName === "pixStatement" && (
          <PixStatementFilter
            tableName={tableName}
            setPageToFirst={setPageToFirst}
          />
        )}
        {tableName === "receipt" && (
          <ReceiptFilter
            tableName={tableName}
            setPageToFirst={setPageToFirst}
          />
        )}
        {(tableName === "extract" || tableName === "refunds") && (
          <ExtractFilter
            tableName={tableName}
            setPageToFirst={setPageToFirst}
          />
        )}
        {tableName === "transfers" && (
          <TransfersFilter
            tableName={tableName}
            setPageToFirst={setPageToFirst}
          />
        )}
        {tableName === "tickets" && (
          <TicketsFilter
            tableName={tableName}
            setPageToFirst={setPageToFirst}
          />
        )}
        {tableName === "invoices" && (
          <InvoiceFilter
            tableName={tableName}
            setPageToFirst={setPageToFirst}
          />
        )}
      </FilterDialog>
    </Box>
  );
};
